import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PermissionGuard } from './services/permissionGuard.interceptor';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import(
        './modules/public/modules/authentication/authentication.module'
      ).then((mod) => mod.AuthenticationModule),
  },
  {
    path: 'perfil',
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import(
            './modules/private/modules/dashboard/dashboard.module'
          ).then((mod) => mod.DashboardModule),
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'dashboard'
        }
      },
      {
        path: 'eecc',
        loadChildren: () =>
          import(
            './modules/private/modules/eecc/eecc.module'
          ).then((mod) => mod.EECCModule),
        data: {
          breadcrumb: 'Estado de Cuenta',

        }
      },
      {
        path: 'movimientos',
        loadChildren: () =>
          import(
            './modules/private/modules/movements/movements.module'
          ).then((mod) => mod.MovementsModule),
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Movimientos'
        }
      },
      {
        path: 'valor-cuota',
        loadChildren: () =>
          import(
            './modules/private/modules/valorCuota/value-share.module'
          ).then((mod) => mod.ValueShareModule),
        data: {
          breadcrumb: 'Valor Cuota'
        }
      },
      {
        path: 'rescates',
        loadChildren: () =>
          import(
            './modules/private/modules/rescues/rescues.module'
          ).then((mod) => mod.RescuesModule),
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Rescatar Cuotas'
        }
      },
      {
        path: 'consulta-saldos',
        loadChildren: () =>
          import(
            './modules/private/modules/check-balances/check-balances.module'
          ).then((mod) => mod.CheckBalancesModule),
        data: {
          breadcrumb: 'Saldos'
        }
      },
      {
        path: 'suscripcion',
        loadChildren: () =>
          import(
            './modules/private/modules/suscription/suscription.module'
          ).then((mod) => mod.SuscriptionModule),
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Suscribir Cuotas'
        }
      },
      {
        path: 'cancelrescates',
        loadChildren: () =>
          import(
            './modules/private/modules/cancel-rescues/cancel-rescues.module'
          ).then((mod) => mod.CancelRescuesModule),
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Cancelar Rescate'
        }
      },
      {
        path: 'traspaso',
        loadChildren: () =>
          import(
            './modules/private/modules/traspaso/traspaso.module'
          ).then((mod) => mod.TraspasoModule),
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Traspaso entre Fondos'
        }
      },
      {
        path: 'transferencias',
        loadChildren: () =>
          import(
            './modules/private/modules/transfer/transfer.module'
          ).then((mod) => mod.TransferModule),
        canActivate: [PermissionGuard],
        data: {
          breadcrumb: 'Transferencia entre cuentas de participación'
        }
      },
      {
        path: 'afiliacion',
        loadChildren: () =>
          import(
            './modules/private/modules/afiliacion/afiliacion.module'
          ).then((mod) => mod.AfilacionModule),
        data: {
          breadcrumb: 'Suscripción a débito automático'
        }
      },
      {
        path: 'documentos',
        loadChildren: () =>
          import(
            './modules/private/modules/documents/documents.module'
          ).then((mod) => mod.DocumentsModule),
        data: {
          breadcrumb: 'Documentos'
        }

      },
      {
        path: 'configuracion',
        loadChildren: () =>
          import(
            './modules/private/modules/configuration/configuration.module'
          ).then((mod) => mod.ConfigurationModule),
        data: {
          breadcrumb: 'Configurar Cuenta'
        }
      },
      {
        path: 'constancia',
        loadChildren: () =>
          import(
            './modules/private/modules/constancy/constancy.module'
          ).then((mod) => mod.ConstancyModule),
        data: {
          breadcrumb: 'Constancia de Cliente'
        }
      },
      {
        path: 'mis-fondos',
        loadChildren: () =>
          import(
            './modules/private/modules/rendimientos/rendimientos.module'
          ).then((mod) => mod.RendimientosModule),
        data: {
          breadcrumb: 'Mis Rendimientos'
        }
      },
      {
        path: 'mi-portafolio',
        loadChildren: () =>
          import(
            './modules/private/modules/portafolio/portafolio.module'
          ).then((mod) => mod.PortafolioModule),
        data: {
          breadcrumb: 'Mis Rendimientos'
        }
      },
      {
        path: 'transferencia-tercero',
        loadChildren: () =>
          import(
            './modules/private/modules/transfer-tercero/transfer-tercero.module'
          ).then((mod) => mod.TransferTerceroModule),
        data: {
          breadcrumb: 'Transferencia a terceros'
        }
      },
      {
        path: 'transferencia-confirmar',
        loadChildren: () =>
          import(
            './modules/private/modules/transfer-confirmar/transfer-confirmar.module'
          ).then((mod) => mod.TransferConfirmarModule),
        data: {
          breadcrumb: 'Confirmación'
        }
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
